module.exports = __webpack_public_path__ + "static/media/slab.3095a894.svg";